import { useScreenSize } from "../../hooks/useScreenSize";
import {
  MonitorSummaryData,
  MonitorTableAnalysisItem,
} from "../../types/analysis";
import { CustomButton } from "../CustomButton/CustomButton";
import { MonitorSummaryCard } from "../MonitorSummaryCard/MonitorSummaryCard";
import { MonitorSummaryTable } from "../MonitorSummaryTable/MonitorSummaryTable";

import styles from "./monitor-summary.module.css";

type MonitorSummaryProps = {
  title?: string;
  data: MonitorSummaryData;
  tableData?: MonitorTableAnalysisItem[];
  selectedView?: "summary" | "table";
  onViewChange?: (view: "summary" | "table") => void;
};

const CONFIG = {
  infestation: {
    label: "Befall",
    color: "#FF8A8D",
  },
  noInfestation: {
    label: "Kein Befall",
    color: "#5EC96C",
  },
  unreachableOrMissing: {
    label: "Nicht erreichbar",
    color: "#F5A752",
  },
  maintenance: {
    label: "Pflege",
    color: "#15A8FB",
  },
  notChecked: {
    label: "Nicht kontrolliert",
    color: "#3D5170",
  },
  total: {
    label: "Gesamt",
    color: "#3D5170",
  },
};

export const MonitorSummary = ({
  title = "Monitore",
  data,
  tableData,
  selectedView = "summary",
  onViewChange = () => {},
}: MonitorSummaryProps) => {
  const { isDesktop } = useScreenSize();

  const items = Object.entries(CONFIG).map(([key, config]) => ({
    label: config.label,
    value: data[key as keyof typeof data],
    color: config.color,
  }));

  return (
    <div className={styles.wrapper}>
      <div className={styles.headerRow}>
        <span className={styles.title}>{title}</span>
        <div className={styles.buttonGroup}>
          <CustomButton
            customClass={styles.noShadow}
            color={
              selectedView === "summary"
                ? "green"
                : isDesktop
                  ? "white"
                  : "transparent"
            }
            icon={selectedView === "summary" ? "summary" : "summaryDark"}
            width={isDesktop ? 24 : 16}
            iconSize={isDesktop ? 14 : 8}
            onClick={() => onViewChange("summary")}
          />
          <CustomButton
            customClass={styles.noShadow}
            color={
              selectedView === "table"
                ? "green"
                : isDesktop
                  ? "white"
                  : "transparent"
            }
            icon={selectedView === "table" ? "table" : "tableDark"}
            width={isDesktop ? 24 : 16}
            iconSize={isDesktop ? 14 : 8}
            onClick={() => onViewChange("table")}
          />
        </div>
      </div>

      {selectedView === "summary" ? (
        <div className={styles.grid}>
          {items.map((item, index) => (
            <div key={index} className={styles.box}>
              {isDesktop ? (
                <div className={styles.value} style={{ color: item.color }}>
                  {item.value}
                </div>
              ) : (
                <div className={styles.valueImageWrapper}>
                  <div className={styles.value} style={{ color: item.color }}>
                    {item.value}
                  </div>
                </div>
              )}
              
              <div className={styles.label}>{item.label}</div>
            </div>
          ))}
        </div>
      ) : (
        <>
          {isDesktop ? (
            <MonitorSummaryTable tableData={tableData || []} />
          ) : (
            <MonitorSummaryCard tableData={tableData || []} />
          )}
        </>
      )}
    </div>
  );
};
